<template>
    <div id="page-integrations">
        <AppBreadCrumb :paths="[{ title: $t('message.integrations') }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">{{ $t("message.allIntegrations") }}</div>
                <div class="stories">
                    <div class="story">
                        <div class="status">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img supsis">
                            <SupsisIcon />
                        </div>
                        <div class="title">{{ $t("message.chatWidget") }}</div>
                    </div>
                    <div class="story" @click="$router.push('/integrations/webhook')">
                        <div class="img webhooks">
                            <WebhookIcon />
                        </div>
                        <div class="title">{{ $t("message.webhooks") }}</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Webhooks" }) }} .</div>
                    </div>
                    <div
                        class="story"
                        @click="$router.push('integrations/whatsapp-v1')"
                        v-if="multiWhatsapp && checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name)"
                    >
                        <div class="status" v-if="whatsappV1ChannelExists">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img whatsapp">
                            <WhatsappV1 style="width: 40px" />
                        </div>
                        <div class="title">Whatsapp V1 (Web)</div>
                        <div>
                            {{ $t("message.integrationsWhatsappV1") }}
                        </div>
                    </div>

                    <div
                        class="story"
                        @click="$router.push('integrations/whatsapp-v2')"
                        v-if="
                            multiWhatsapp &&
                            checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name) &&
                            istWhatsappV2()
                        "
                    >
                        <div class="status" v-if="whatsappV2ChannelExists">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img whatsapp">
                            <span class="material-icons star-v2"> star </span>
                            <WhatsappV2 style="width: 40px" />
                        </div>
                        <div class="title">Whatsapp V2 (Web)</div>
                        <div>
                            {{ $t("message.integrationsWhatsappV2") }}
                        </div>
                    </div>
                    <div
                        v-if="checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name)"
                        class="story"
                        @click="$router.push('integrations/whatsapp-business-api')"
                    >
                        <div class="status" v-if="whatsappBusinessChannelExists">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img whatsapp">
                            <WhatsappBusinessIcon style="width: 50px" />
                        </div>
                        <div class="title">Whatsapp Business API</div>
                        <div>
                            {{ $t("message.integrationsWhatsappBusiness") }}
                        </div>
                    </div>
                    <div class="story" @click="$router.push('integrations/instagram')">
                        <div class="status" v-if="instagramChannelExists">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img instagram">
                            <InstagramIcon />
                        </div>
                        <div class="title">Instagram</div>
                        <div>
                            {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Instagram" }) }}
                            {{ $t("message.planRequired", { integratable: "Instagram" }) }}
                        </div>
                    </div>
                    <div class="story" @click="$router.push('integrations/messenger')">
                        <div class="status" v-if="messengerChannelExists">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img messenger">
                            <FacebookIcon />
                        </div>
                        <div class="title">Messenger</div>
                        <div>
                            {{$t('message.messengerIntegrationDesc') }}
                        </div>
                    </div>
                    <div
                        v-if="checkPermission(PERMISSION_TYPES['integrations.telegram.view'].tr.name)"
                        class="story"
                        @click="integrateTelegramModalVisible = true"
                    >
                        <div class="status" v-if="telegramEnabled">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <a-modal
                            :title="$t('telegram.telegramTokenTitle')"
                            wrapClassName="vertical-center-modal"
                            :visible="integrateTelegramModalVisible"
                            @cancel="handleCancel()"
                            @ok="handleOk()"
                        >
                            <div class="col mb-5">
                                <a-form-item :label="$t('telegram.typeInTelegramToken')">
                                    <a-modal
                                        v-model="visibleDeleteToken"
                                        :title="$t('telegram.telegramAlertTitle')"
                                        @ok="confirmDeleteToken"
                                        @cancel="cancelDeleteToken"
                                    >
                                        <p>{{ $t("telegram.telegramAlertText") }}</p>
                                    </a-modal>
                                    <div class="row mb-3">
                                        <a-input
                                            style="width: 90%"
                                            autofocus
                                            class="mt-2"
                                            :class="{ 'err-class': showWarning }"
                                            @change="onTelegramTokenChange"
                                            v-model="tempToken"
                                            :placeholder="$t('telegram.token')"
                                        />
                                        <a-button
                                            type="primary"
                                            icon="delete"
                                            v-if="isThereTempToken"
                                            class="ml-2 p-10 mt-2"
                                            @click="showDeleteConfirmation"
                                        ></a-button>
                                    </div>
                                </a-form-item>

                                <a-alert show-icon type="info">
                                    <div slot="description">
                                        {{ $t("telegram.telegramAlertForm") }}
                                        <a href="https://t.me/BotFather" target="_blank">BotFather</a>
                                    </div>
                                </a-alert>
                            </div>
                        </a-modal>
                        <div class="img telegram">
                            <TelegramIcon />
                        </div>
                        <div class="title">Telegram</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Telegram" }) }}</div>
                    </div>
                    <div class="story" @click="$router.push('integrations/mail')" v-if="isEmailFeatureEnabled()">
                        <div class="img mail">
                            <MaliIcon />
                        </div>
                        <div class="title">Mail</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Mail" }) }}</div>
                    </div>
                    <div class="story" @click="$router.push('integrations/sms/postacell')">
                        <div class="status" v-if="smsChannels.length > 0">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img postacell"><img src="/static/img/postacell-logo.png" /></div>
                        <div class="title">SMS - Postacell</div>
                        <div>Activate sending SMS via PostaCELL SMS Provider</div>
                    </div>
                    <div class="story" @click="$router.push('integrations/openai')">
                        <div class="status" v-if="openaiChannels.length > 0">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img">
                            <OpenaiIcon />
                        </div>
                        <div class="title">OpenAI</div>
                        <div>
                            Activate OpenAI Services - Chatbot AI Response - AI Assistant CoPilot - Chatbot AI Knowledge
                            Base
                        </div>
                    </div>
                    <div class="story" @click="$router.push('integrations/ideasoft')">
                        <div class="status" v-if="ideasoftChannels.length > 0">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img ideasoft">
                            <IdeasoftIcon />
                        </div>
                        <div class="title">Ideasoft</div>
                        <div>Activate Ideasoft API for enchanced chatbot experience to your customers.</div>
                    </div>
                    <div class="story" @click="$router.push('integrations/ticimax')">
                        <div class="status" v-if="ticimaxChannels.length > 0">
                            <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                        </div>
                        <div class="img ticimax">
                            <div class="img postacell"><img src="/static/img/ticimax.png" /></div>
                        </div>
                        <div class="title">Ticimax</div>
                        <div>Send automated message to segmented ticimax members.</div>
                    </div>

                    <div class="story voting" @click="">
                        <div class="img twitter">
                            <TwitterIcon />
                        </div>
                        <div class="title">Twitter</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Twitter" }) }}</div>
                    </div>
                    <div class="story voting" @click="">
                        <div class="img skype">
                            <SkypeIcon />
                        </div>
                        <div class="title">Skype</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Skype" }) }}</div>
                    </div>
                    <div class="story voting" @click="">
                        <div class="img shopify">
                            <ShopifyIcon />
                        </div>
                        <div class="title">Shopify</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Shopify" }) }}</div>
                    </div>
                    <div class="story voting" @click="">
                        <div class="img slack">
                            <SlackIcon />
                        </div>
                        <div class="title">Slack</div>
                        <div>{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Slack" }) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideMenuBar from "./Chatbot/SideMenuBar";
import { mapActions, mapGetters, mapState } from "vuex";
import WebhookIcon from "./Chatbot/pages/integrations/svg/WebhookIcon";
import OpenaiIcon from "./Chatbot/pages/integrations/svg/OpenaiIcon";
import SupsisIcon from "./Chatbot/pages/integrations/svg/SupsisIcon";
import WhatsappIcon from "./Chatbot/pages/integrations/svg/WhatsappIcon";
import InstagramIcon from "./Chatbot/pages/integrations/svg/InstagramIcon";
import TelegramIcon from "./Chatbot/pages/integrations/svg/TelegramIcon";
import TwitterIcon from "./Chatbot/pages/integrations/svg/TwitterIcon";
import FacebookIcon from "./Chatbot/pages/integrations/svg/FacebookIcon";
import SkypeIcon from "./Chatbot/pages/integrations/svg/SkypeIcon";
import ShopifyIcon from "../../components/fast-initialize/svg/ShopifyIcon";
import SlackIcon from "./Chatbot/pages/integrations/svg/SlackIcon";
import MaliIcon from "./Chatbot/pages/integrations/svg/MailIcon";
import _ from "lodash";
import IntegrateChatBotWithChatGPT3 from "./Chatbot/pages/integrations/components/IntegrateChatBotWithChatGPT3";
import { sendSocketMessage } from "../../utils/socketStream";
import log2 from "../../utils/log2";
import WhatsappBusinessIcon from "./Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import CONFIG from "../../config/config";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import AppBreadCrumb from "../../components/common/AppBreadCrumb.vue";
import WhatsappV1 from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV1.vue";
import WhatsappV2 from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import IdeasoftIcon from "./Chatbot/pages/integrations/svg/IdeasoftIcon.vue";
import MessengerIcon from "./Chatbot/pages/integrations/svg/MessengerIcon.vue";

const log = log2("Integrations");
export default {
    name: "Integrations",
    components: {
        MessengerIcon,
        IdeasoftIcon,
        AppBreadCrumb,
        SlackIcon,
        ShopifyIcon,
        SkypeIcon,
        FacebookIcon,
        TwitterIcon,
        WhatsappIcon,
        InstagramIcon,
        TelegramIcon,
        SupsisIcon,
        SideMenuBar,
        WebhookIcon,
        OpenaiIcon,
        IntegrateChatBotWithChatGPT3,
        WhatsappBusinessIcon,
        MaliIcon,
        WhatsappV1,
        WhatsappV2,
    },
    data() {
        return {
            integrateTelegramModalVisible: false,
            showWarning: false,
            tempToken: "",
            visibleDeleteToken: false,
            handleSaveSetting: _.debounce((newSettings) => {
                this.updateSettings(newSettings);
            }, 100).bind(this),
            multiWhatsapp: CONFIG.MULTI_WHATSAPP.enabled,
            isThereTempToken: false,
            PERMISSION_TYPES,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            emailDomain: (state) =>
                state.site.site.alias === "supsis"
                    ? CONFIG.EMAIL_DOMAIN
                    : `${state.site.site.alias}.${CONFIG.EMAIL_DOMAIN}`,
            whatsappV1ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-qr"),
            whatsappV2ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-v2"),
            whatsappBusinessChannelExists: (state) =>
                state.channel.channels.some((x) => x.type === "whatsapp-business-api"),
            instagramChannelExists: (state) => state.channel.channels.some((x) => x.type === "instagram"),
            messengerChannelExists: (state) => state.channel.channels.some((x) => x.type === "messenger"),
            smsChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
            openaiChannels: (state) => state.channel.channels.filter((x) => x.type === "openai"),
            ideasoftChannels: (state) => state.channel.channels.filter((x) => x.type === "ideasoft"),
            ticimaxChannels: (state) => state.channel.channels.filter((x) => x.type === "ticimax"),
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            telegramEnabled: "setting/telegramEnabled",
            checkPermission: "auth/checkPermission",
        }),
        token: {
            get() {
                return _.get(this.settings, "telegrambot.token", null);
            },
            async set(value) {
                await this.setValue("telegrambot.token", value);
                this.updateTelegramToken(value);
            },
        },
    },
    methods: {
        showDeleteConfirmation() {
            this.visibleDeleteToken = true;
            this.visibleDeleteToken = false;
            this.tempToken = "";
        },
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        isEmailFeatureEnabled() {
            return CONFIG.EMAIL_SERVICE_ENABLED;
        },
        updateTelegramToken(token) {
            log("updateTelegramToken", token);
            // this.setValue("telegrambot.token", token);
            sendSocketMessage("admin settings-updated", {
                siteId: this.site._id,
            });
            setTimeout(() => {
                sendSocketMessage("telegram subscribe", {
                    siteId: this.site._id,
                });
            }, 500);
        },
        deleteTelegramToken() {
            this.setValue("telegrambot.token", null);
        },
        handleOk() {
            if (!!this.tempToken && !!this.tempToken.length) {
                this.showWarning = false;
                this.setValue("telegrambot.token", this.tempToken);
            } else {
                this.showWarning = true;
            }
            this.integrateTelegramModalVisible = false;
            sendSocketMessage("user settings-updated", {
                siteId: this.site._id,
            });
        },
        handleCancel() {
            this.integrateTelegramModalVisible = false;
            this.tempToken = this.token;
        },
        onTelegramTokenChange(e) {
            console.log("onTelegramTokenChange", e.target.value);
            this.tempToken = e.target.value;
            this.showWarning = false;
        },
        confirmDeleteToken() {
            this.deleteTelegramToken();
            this.visibleDeleteToken = false;
            this.integrateTelegramModalVisible = false;
        },
        cancelDeleteToken() {
            this.tempToken = this.token;
            this.visibleDeleteToken = false;
        },
        async setValue(key, value) {
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });

            if (newSettings.then) {
                return newSettings.then((x) => this.handleSaveSetting(x));
            } else {
                return this.handleSaveSetting(newSettings);
            }
        },
        istWhatsappV2() {
            return CONFIG.WHATSAPP_V2;
        },
    },
    mounted() {
        if (!!this.token) this.tempToken = this.token;
        const query = this.$route.query;
        if (query.showModal && query.showModal === "true") {
            this.integrateTelegramModalVisible = true;
        }
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["integrations.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        token(newVal, oldVal) {
            if (!!newVal && !!newVal.length > 0) {
                if (!oldVal) {
                    this.tempToken = newVal;
                }
            }
        },
        tempToken(newVal) {
            if (newVal === "") {
                this.visibleDeleteToken = true;
            }
            if (newVal) {
                if (newVal.length > 0) {
                    this.isThereTempToken = true;
                } else {
                    this.isThereTempToken = false;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#page-integrations {
    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .stories {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            position: relative;
            background: #fff;
            border-radius: 4px;
            padding: 20px;
            cursor: pointer;
            transition: all 0.3s;
            width: 280px;
            min-width: 250px;
            max-width: 250px;
            height: 216px;
            box-shadow: 0 1px 15px rgb(0 0 0 / 4%);
            border: 1px solid #dbe1e8;

            .status {
                background-color: #f5f8fb;
                border: 1px solid #dbe1e8;
                border-radius: 6px;
                color: #919ead;
                font-size: 12px;
                font-weight: 600;
                padding: 5px 7px;
                position: absolute;
                right: 10px;
                top: 10px;
                display: flex;
                justify-content: center;
                align-items: center;

                .material-icons {
                    float: left;
                    font-size: 15px;
                    margin-right: 5px;
                }
            }

            &.voting {
                background: #ebeef2;

                &:after {
                    background: #008aff;
                    border-radius: 6px;
                    color: #fff;
                    content: "VOTING";
                    font-size: 13px;
                    font-weight: 600;
                    padding: 5px 10px;
                    position: absolute;
                    right: 10px;
                    top: 10px;
                }
            }

            &:hover {
                border: 1px solid #008aff;

                .img:after {
                    transform: rotate(45deg) translate(-20%, -150%);
                    transition: all 0.4s;
                }
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .img {
                width: 70px;
                height: 70px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-bottom: 15px;
                overflow: hidden;
                position: relative;

                &.webhooks {
                    background: #7159c2;
                }

                &.postacell,
                &.ticimax {
                    width: 180px;
                }

                &.ideasoft {
                    width: 180px;
                }

                &.supsis {
                    background: #e8eef3;
                }

                &.openai {
                    background: #a2cbed;
                }

                &.whatsapp {
                    background: #58ca64;
                }

                &.instagram {
                    background: #d6249f;
                    background: radial-gradient(
                        circle at 30% 107%,
                        #fdf497 0%,
                        #fdf497 5%,
                        #fd5949 45%,
                        #d6249f 60%,
                        #285aeb 90%
                    );
                }

                &.telegram {
                    background: #29b6f6;
                }

                &.twitter {
                    background: #3ecdfb;
                }

                &.slack {
                    background: #634360;
                }

                &.mail {
                    justify-content: unset !important;
                }

                &.facebook,
                &.skype,
                &.shopify {
                    background: #ffffff;
                }

                svg {
                    width: 60%;
                }

                &:after {
                    background: #fff;
                    bottom: 0;
                    content: "";
                    height: 100%;
                    left: -10%;
                    opacity: 0.3;
                    position: absolute;
                    top: 0;
                    transform: rotate(45deg) translate(-20%, 150%);
                    width: 160%;
                }
            }
        }
    }
}

.star-v2 {
    position: absolute !important;
    top: 0px !important;
    right: 0px !important;
    color: yellow !important;
}
</style>
